// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2O4qp","resendInfoText":"OnGoingPaymentBox_resendInfoText__ODouo"};